<template>
    <div class="exception">
        <div class="img">
            <img :src="config[type].img"/>
        </div>
        <div class="content">
            <h1>{{ config[type].title }}</h1>
            <div class="desc">{{ config[type].desc }}</div>
            <div class="action">
                <a-button type="primary" @click="handleToHome">返回首页</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import types from './type'

export default {
    name: 'ExceptionPage',
    props: {
        type: {
            type: String,
            default: '404'
        }
    },

    data: function () {
        return {
            config: types
        }
    },

    methods: {
        handleToHome: function () {

        }
    }
}
</script>

<style lang='less' scoped>
.exception {
    min-height: 500px;
    height: 80%;
    align-items: center;
    text-align: center;
    padding-top: 150px;
}

.content {
    padding-top: 24px;
}

.desc {
    padding-bottom: 24px;
}
</style>
